import classNames from "classnames"
import styles from "./styles.module.scss"
import PageHeader, { IPageHeader } from "./page-header"

interface IMainProps extends React.PropsWithChildren {
  overflow?: boolean
  className?: string
}
export interface IMain extends React.FC<IMainProps> {
  PageHeader: React.FC<IPageHeader>
}

const Main: IMain = ({ children, overflow, className = "" }) => {
  return (
    <div
      className={classNames(
        styles.page__wrapper,
        !overflow && styles.overflow_y_auto
      )}
    >
      <div
        className={classNames(
          styles.page__content,
          overflow && styles.overflow,
          className
        )}
      >
        {children}
      </div>
    </div>
  )
}

Main.PageHeader = PageHeader

export default Main
